export default __webpack_public_path__ + "static/zohoImage-f94080157daeca6252b6ffceea1f8bf6.webp";